export function isRealm(realm) {
    return (realm === 'JobsDB-Candidate' ||
        realm === 'Candidate' ||
        realm === 'Employer' ||
        realm === 'Business-Authentication' ||
        realm === 'Username-Password-Authentication' ||
        realm === 'seek-okta-global');
}
export var Site = {
    HIRER: 'hirer',
    SEEKJOBS: 'seekjobs',
    SEEKPASS: 'seekpass',
};
export var Brand = {
    JOBSDB: 'jobsdb',
    JOBSTREET: 'jobstreet',
    SEEK: 'seek',
    SEEKPASS: 'seekpass',
};
export var Product = {
    HIRER: 'hirer',
    SEEK: 'seek',
    SEEKBUSINESS: 'seekbusiness',
    SEEKPASS: 'seekpass',
};
//# sourceMappingURL=types.js.map